import { authentication } from '@ecosystem/newron-client-lib';
import axios from 'axios';
import { Context, Entity, Params } from '../types';
import { clientToImpersonate } from './impersonate';
import { SimpleMessageError } from '../design/error/simpleMessageError';
import { DEFAULT_ERROR_MESSAGE } from '../common/constants/error';
import { getFeatureFlagHeaders } from './featureFlags';
import { isBulkExportPage } from '../content/collection/utils';
import { BULK_EXPORT_URL } from '../data';

async function getContext(url: string, params: Params): Promise<Context> {
  if (isBulkExportPage()) url += BULK_EXPORT_URL;

  const token = await authentication.getAccessToken();
  try {
    const search = new URLSearchParams();
    Object.keys(params).forEach(name => {
      const values = params[name];
      values?.forEach(value => {
        search.append(name, value);
      });
    });

    const response = await axios.post<Context>(url, params, {
      headers: {
        Authorization: `Bearer ${token}`,
        ...(await clientToImpersonate()),
        ...(await getFeatureFlagHeaders()),
      },
    });
    if (!response.data) {
      throw new SimpleMessageError();
    }
    return response.data;
  } catch (err) {
    if (axios.isAxiosError(err)) {
      throw new SimpleMessageError(err.response?.data);
    }
    throw new SimpleMessageError();
  }
}

async function getContextSettingOptions(url: string, params: Params): Promise<(Entity | string)[]> {
  if (isBulkExportPage()) url += BULK_EXPORT_URL;
  const token = await authentication.getAccessToken();
  try {
    const search = new URLSearchParams();
    Object.keys(params).forEach(name => {
      const values = params[name];
      values?.forEach(value => {
        search.append(name, value);
      });
    });

    const storage = JSON.parse(localStorage.getItem('impersonation'));
    if (storage && authentication.getUser().userId.startsWith('oauth2|gfk-aad')) {
      search.append('client_id', storage['client_id']);
      search.append('client_user_group_ids', storage['client_user_group_ids']);
    }

    const { data } = await axios.get<(Entity | string)[]>(url, {
      headers: {
        Authorization: `Bearer ${token}`,
        ...(await clientToImpersonate()),
        ...(await getFeatureFlagHeaders()),
      },
      params: search,
    });
    return data;
  } catch (err) {
    throw new SimpleMessageError(err?.response?.data || DEFAULT_ERROR_MESSAGE);
  }
}

export const contextClient = {
  getContext,
  getContextSettingOptions,
};
